<template>
    <div class="kgk-register">
        <RegisterForm :invite-id="$route.params.inviteId" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import RegisterForm from '@/components/login/RegisterForm.vue';

    export default {
        name: 'Register',
        components: {
            RegisterForm,
        },
        mounted() {
            /*this.$global.message = 'CHANGED YAY';
            this.$global.session.token = 'tokenXY';
            console.log(this.$global);*/
        }
    }
</script>
